import { Component, OnInit, Input, HostListener, AfterViewInit, AfterContentInit, AfterViewChecked, ElementRef, ViewChild, OnDestroy, Inject, PLATFORM_ID, signal, computed } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, NavigationExtras, NavigationStart } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { UIHeaderService } from '../serviceLayer/ui-header.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { SignupEventService } from '../serviceLayer/signup-event.service';
import { ChangeDetectorRef } from '@angular/core';
import { SharedService } from '../serviceLayer/shared.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ModalPopupComponent } from '../layout1/modal-popup/modal-popup.component';
import { ToastrService } from 'ngx-toastr';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { DatePipe } from '@angular/common';
import { PublicService } from '../serviceLayer/public-service';
import { BuyerService } from '../serviceLayer/buyer-service';
import { LanguageService } from '../serviceLayer/language.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('submenuToggle', [
      state('closed', style({
        height: '0px',
        opacity: 0,
        overflow: 'hidden'
      })),
      state('open', style({
        height: '*',
        opacity: 1,
        overflow: 'visible'
      })),
      transition('closed <=> open', [
        animate('300ms ease-in-out')
      ]),
    ])
  ]

})


export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('dropdownToggle', { static: true }) dropdownToggle!: ElementRef;
  @ViewChild('auctionsMenu', { static: false }) auctionsMenu!: ElementRef;
  @ViewChild('sellMenu', { static: false }) sellMenu!: ElementRef;
  showSubmenu = signal(false);
  showLaneSubmenu = signal(false);
  showSellSubmenu = signal(false);
  Howitworks = signal(false);
  isScrolled = signal(false);

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled.set(window.scrollY > 0);
  }

  checkURL = signal(false);
  userSessions: any = [];
  currentUser = signal<any>(null);
  shortName = computed(() => this.currentUser()?.name?.slice(0, 2).toUpperCase() || '');
  currentLang = signal('');
  hideHeader = signal(false);
  showAuctionJoinMessage = signal(true);

  @Input() ClassGet;
  car: any;
  customLoader = signal(false);
  page: number = 1;
  itemPerPage: number = 10;
  todayAuctionsList = signal<any[]>([]);
  auctionList = signal<any[]>([]);
  totalCount = signal<number>(0);
  notFound = signal(false);
  isBrowser = signal(false);

  constructor(
    private router: Router,
    private authService: AuthService,
    private signupEventService: SignupEventService,
    private cdr: ChangeDetectorRef,
    private sharedService: SharedService,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private toastService: ToastrService,
    private datePipe: DatePipe,
    private spinner: SpinnerVisibilityService,
    private publicService: PublicService,
    private buyerService: BuyerService,
    private languageService: LanguageService,
    private translate: TranslateService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUser.set(this.authService.currentUserValue);
        this.checkRouteToHideMessage();
      }
    });
  }

  ngOnInit(): void {
    this.currentUser.set(this.authService.currentUserValue);
    this.currentLang.set(this.languageService.getCurrentLang() || 'eng');
    this.isBrowser.set(isPlatformBrowser(this.platformId));
    this.checkRouteToHideMessage();
  }

  ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId)) return;
    this.getAuctionList(this.page, this.itemPerPage);
    this.auctionJoinHide();
    this.hideHeader.set(true);
  }

  ngOnDestroy(): void {
    // no-op
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!this.auctionsMenu?.nativeElement?.contains(target)) {
      this.showSubmenu.set(false);
      this.showLaneSubmenu.set(false);
    }
    if (!this.sellMenu?.nativeElement?.contains(target)) {
      this.showSellSubmenu.set(false);
    }
  }
  onDropdownOpen(): void {
    this.getAnalytics(); // Your existing API call
  }

  analyticdata = signal<any>({});
  getAnalytics() {
    let data = {
      userId: this.currentUser()?._id,
    };
    this.buyerService.getBuyerAnalytics(data).subscribe((res: any) => {
      if (res.status == true) {
        this.analyticdata.set(res.data);
      }
    });
  }

  changeLanguage() {
    const newLang = this.currentLang() === 'eng' ? 'ara' : 'eng';
    this.currentLang.set(newLang);
    this.languageService.setLanguage(newLang);
  }

  /**
   * Helper method to get language-aware route
   */
  getLangRoute(route: string): string {
    return this.languageService.getLanguageAwareUrl(route);
  }

  auctionJoin(data: any, lane: string = 'unassigned') {


    if (!this.currentUser()) {
      this.toastService.info(this.translate.instant('auctions.message1'), this.translate.instant('tooltips.warning'));
      return
    }
    // if (this.currentUser()?.status != 1) {
    //   this.toastService.info(this.translate.instant('auctions.message2'), this.translate.instant('tooltips.info'));
    //   return
    // }
    if (this.currentUser()) {
      if (this.currentUser()?.userType === 4 || this.currentUser()?.userType === 5)
        this.router.navigateByUrl(`auction-join?id=${data?._id}${lane != 'unassigned' ? '&&lane=' + lane : ''}`);
      else
        this.toastService.warning(this.translate.instant('auctions.message1'), this.translate.instant('tooltips.warning'));
    } else {
      this.toastService.warning(this.translate.instant('auctions.message1'), this.translate.instant('tooltips.warning'))
    }
  }

  private checkRouteToHideMessage(): void {
    const currentRoute = this.router.url;
    const routesToHide = ['job-listing', 'job-Description', 'job-Apply'];
    this.showAuctionJoinMessage.set(!routesToHide.some(route => currentRoute.includes(route)));
  }

  checkTimeOver(end: any) {
    let hour: any = end.split("T")[1].split(":")[0];
    let min: any = end.split("T")[1].split(":")[1];
    let formatedTime = this.datePipe.transform(end, 'yyyy-MM-dd HH:mm', 'UTC');
    let time = new Date(formatedTime);
    // time.setHours(parseInt(hour));
    // time.setMinutes(parseInt(min));
    const timeDiff = time.getTime() - new Date().getTime();
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
    if (seconds < 0) {
      return true
    }
  }

  compareDate(startDate: any, id: any) {
    let auctionStartDataTime = new Date(startDate).getTime();
    let currentDate = new Date().getTime();
    //capare Date and Time
    if (currentDate > auctionStartDataTime) {
      const auctionUrl = this.languageService.getLanguageAwareUrl('auction-join?id=' + id);
      this.router.navigateByUrl(auctionUrl);
    } else {
      this.toastService.error(this.translate.instant('auctions.message3'));
    }
  }

  getAuctionList(page: any, pageLimit: any) {
    // this.spinner.show();
    this.customLoader.set(true);
    let data = {
      pageLimit: pageLimit,
      page: page,
      inventoryStatus: 2,
      pendingcar: true,
      isAuctionActive: true,
      orderBy: 'auctionDate',
      fromDate: this.datePipe.transform(new Date().setDate(new Date().getDate() - 1), 'yyyy-MM-dd'),
      toDate: this.datePipe.transform(
        new Date().setDate(new Date().getDate() + 2),
        'yyyy-MM-dd'
      ),
    };


    this.publicService.auctionListWithDate(data).subscribe((res: any) => {
      if (res.status == true) {
        const today: any[] = [];
        const others: any[] = [];
        res.data.forEach((element: any) => {
          this.isToday(element.auctionDate) ? today.push(element) : others.push(element);
        });
        this.todayAuctionsList.set(today);
        this.auctionList.set(others);
        this.cdr.detectChanges();
      }
      this.customLoader.set(false);
    });
    // this.spinner.hide();
  }

  isAuctionJoinShow = signal(false);
  auctionJoinHide() {
    this.sharedService.isShowheader$.subscribe((val: any) => {
      this.isAuctionJoinShow.set(val === true);
    });
  }

  toggleSubmenu(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.showSubmenu.update(v => !v);
  }

  toggleLaneSubmenu(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.showLaneSubmenu.update(v => !v);
  }

  get todayAuctionLanes(): any[] {
    const lanes = this.todayAuctionsList()?.[0]?.lanes || [];
    return lanes.filter((lane: any) => lane?.lane && lane.lane !== 'unassigned');
  }

  get hasMultipleLanes(): boolean {
    return (this.todayAuctionsList()?.[0]?.lanes || []).length > 1;
  }

  isToday(dateString: string): boolean {
    const today = new Date();
    const date = new Date(this.datePipe.transform(dateString, 'yyyy-MM-dd', 'UTC'));
    let returnValue = false;
    if (date.getDate() <= today.getDate() &&
      date.getMonth() <= today.getMonth() &&
      date.getFullYear() <= today.getFullYear()) {
      returnValue = true
    }
    else {
      returnValue = false;
    }
    return returnValue;
  }

  HeaderStyle1() {
    this.hideHeader.set(false);
    setTimeout(() => {
      this.hideHeader.set(true);
    }, 3000);
    this.sharedService.hideFooterElement(true);
    this.checkURL.set(true);
  }
  HeaderStyle2() {
    this.checkURL.set(false);
  }

  logout() {
    this.hideHeader.set(false);
    setTimeout(() => {
      this.hideHeader.set(true);
    }, 3000);
    this.sharedService.hideFooterElement(true);

    this.authService.logout();
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    localStorage.removeItem("sortTypeKey");
    localStorage.removeItem("sortTypeOrder");
    localStorage.removeItem("isViewTypeList");

    // Navigate to home with language-aware URL
    const homeUrl = this.currentLang() === 'ara' ? '/ar/home' : '/home';
    this.router.navigateByUrl(homeUrl);
    this.currentUser.set(null);
    //location.reload();
    // this.cdr.detectChanges();
  }

  activateSignUpPopUp(isEnable) {
    this.signupEventService.emit(isEnable)
  }


  lowercaseTitle(title) {
    title = title.toLowerCase();
    return title;
  }
  openNav() {
    document.getElementById("mySidenav").style.width = "44%";
  }
  closeNav() {
    document.getElementById("mySidenav").style.width = "0";
  }
}


